import { render, staticRenderFns } from "./viewPersonnel.vue?vue&type=template&id=3c4b7ec2&scoped=true"
import script from "./viewPersonnel.vue?vue&type=script&lang=js"
export * from "./viewPersonnel.vue?vue&type=script&lang=js"
import style0 from "./viewPersonnel.vue?vue&type=style&index=0&id=3c4b7ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b7ec2",
  null
  
)

export default component.exports